export const defaultAnimationProfile = Object.freeze({
  bodyLanguagePreset: 'neutral',
  basePosture: 'auto',
  gestureIntensity: 0.55,
  postureVariation: 0.15,
  listeningResponsiveness: 0.45,
  semanticReactionsEnabled: true,
});

export const bodyLanguagePresetOptions = Object.freeze([
  { value: 'neutral', label: 'Neutral' },
  { value: 'reserved', label: 'Reserved' },
  { value: 'expressive', label: 'Expressive' },
  { value: 'anxious', label: 'Anxious' },
  { value: 'tired', label: 'Tired' },
  { value: 'defensive', label: 'Defensive' },
]);

export const basePostureOptions = Object.freeze([
  { value: 'auto', label: 'Auto per session' },
  { value: 'normal', label: 'Normal' },
  { value: 'leanForward', label: 'Lean forward' },
  { value: 'leanBack', label: 'Lean back' },
  { value: 'crossLegged', label: 'Cross legged' },
  { value: 'armsCrossed', label: 'Arms crossed' },
  { value: 'slouched', label: 'Slouched' },
]);

const clampUnit = (value, fallback) => {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return fallback;
  }

  return Math.max(0, Math.min(1, number));
};

const pickOption = (value, options, fallback) => (
  options.some((option) => option.value === value) ? value : fallback
);

export const normalizeAnimationProfile = (profile = {}) => {
  const source = profile && typeof profile === 'object' ? profile : {};

  return {
    bodyLanguagePreset: pickOption(
      source.bodyLanguagePreset,
      bodyLanguagePresetOptions,
      defaultAnimationProfile.bodyLanguagePreset
    ),
    basePosture: pickOption(
      source.basePosture,
      basePostureOptions,
      defaultAnimationProfile.basePosture
    ),
    gestureIntensity: clampUnit(
      source.gestureIntensity,
      defaultAnimationProfile.gestureIntensity
    ),
    postureVariation: clampUnit(
      source.postureVariation,
      defaultAnimationProfile.postureVariation
    ),
    listeningResponsiveness: clampUnit(
      source.listeningResponsiveness,
      defaultAnimationProfile.listeningResponsiveness
    ),
    semanticReactionsEnabled: source.semanticReactionsEnabled !== false,
  };
};
